import { VueModule } from '@Foundation/utilities';
import ResponsiveImage from './code/Scripts/components/responsive-image';

export default VueModule({
  components: {
    ResponsiveImage
  }
});
